import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '../../IconButton/IconButton';
import styles from './ShareButton.scss';
import { ShareIcon } from './ShareIcon';
import { ShareTimelineEntryModal } from '../ShareTimelineEntryModal/ShareTimelineEntryModal';

interface ShareButtonProps {
  disabled?: boolean;
  timelineImage?: string;
  description?: string | null;
}

const ShareButton: FunctionComponent<ShareButtonProps> = ({
  disabled = false,
  timelineImage,
  description,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const [isOpen, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        className={`${styles.shareButton} ${disabled ? 'disabled' : ''}`}
        disabled={disabled}
        onClick={openModal}
        aria-label={t('timeline.shareButton')}
      >
        <ShareIcon className={styles.icon} />
      </IconButton>
      {isOpen && (
        <ShareTimelineEntryModal
          onClose={closeModal}
          imageUrl={timelineImage}
          description={description}
        />
      )}
    </>
  );
};

export default ShareButton;
